import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { Grid } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import SystemSettingCard from 'src/Elements/SystemSettings/SystemSettingCard'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'
import { useTypedSelector } from 'src/State/RootReducer'
import useFlowSystemSettingsOverviewCardConfigs from '../hooks/use-flow-system-settings-overview-card-configs'
import { getPropertiesSettingsDetailsRoute } from 'src/Libs/flow/advanced-settings/routes'

/**
 * This is a general overview page for system settings (for Flow theme).
 */
const FlowSystemSettingsOverview: React.FC = () => {
  const { isStorageOnline } = useContext(InstallationOnlineStatusContext)
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()
  const { setTabs } = useHeaderTabs()
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const systemSettingsCardConfigs = useFlowSystemSettingsOverviewCardConfigs()
  const settingsPagePath = getPropertiesSettingsDetailsRoute(activeInstallation?.toString(), activeStorage)

  useEffect(() => {
    dispatch(appUpdate({ title: t('framework.systemProperties') }))
    setTabs([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container>
      <BannerQueue location={BannerLocations.SettingsOverview} sx={{ mt: 2, mb: 0, ml: 2 }} />
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {systemSettingsCardConfigs.map((data, index) => (
            <Grid item xs={6} md={4} key={`setting-card-${data.title}`}>
              <SystemSettingCard
                {...data}
                data-qa={`system-setting-${index}`}
                path={isStorageOnline || data.accessibleWhenInstallationOffline ? data.path : settingsPagePath}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FlowSystemSettingsOverview
